import { motion } from 'motion/react';
import { Globe } from 'lucide-react';

import { useI18n } from '../../i18n';

export default function LanguageSwitcher() {
  const { t, switchLanguage, language } = useI18n();

  return (
    <motion.button
      onClick={switchLanguage}
      className="flex items-center gap-2 rounded-md border border-gray-200 px-3 py-2 text-sm text-gray-700 transition-colors hover:bg-gray-50"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      aria-label={`Switch to ${language === 'ar' ? 'English' : 'Arabic'}`}
    >
      <Globe className="h-4 w-4" />
      <span>{t.languageSwitcher.label}</span>
    </motion.button>
  );
}
